import { CHILDREN_AGES, ADULTS_FIELD } from './fieldsNames';
import { mapValues } from 'lodash';

export const filterKeyNames = [
  'amenities',
  'landmarks',
  'neighborhoods',
  'rating',
  'searchBy',
  'minPrice',
  'maxPrice',
];

export const filtersWithArrays = ['amenities', 'neighborhoods', 'landmarks'];

// "decode" party configuration params for graphql call
export const decodeRoomsFormUrl = rooms => {
  // we only get a number form query param if there is one room with one adult
  if (typeof rooms === 'number') {
    return [{ [ADULTS_FIELD]: rooms, [CHILDREN_AGES]: null }];
  } else {
    // we get an string if there is one room which has adults and children
    return Array.isArray(rooms)
      ? rooms.map(room => decodeRoom(room))
      : [decodeRoom(rooms)];
  }
};

export const decodeRoom = room => {
  const party = room.split(',');
  const adults = parseInt(party[0], 10);
  const childrenAges = party.slice(1).length
    ? party.slice(1).map(age => parseInt(age, 10))
    : null;
  return {
    [ADULTS_FIELD]: adults,
    [CHILDREN_AGES]: childrenAges,
  };
};

export const convertStrToInt = object => {
  return mapValues(object, (value, key) => {
    if (
      typeof value === 'string' &&
      key !== 'searchBy' &&
      value.match(/^-{0,1}\d+$/)
    ) {
      return parseFloat(value);
    } else {
      return value;
    }
  });
};
